module.exports = __webpack_public_path__ + "img/insta.d6b79bbd.svg";